var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloudUploadOrange = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M12 3c2.581 0 4.855 1.661 5.675 4.045C20.114 7.376 22 9.472 22 12c0 1.221-.444 2.396-1.25 3.309-.198.223-.473.338-.75.338-.235 0-.471-.082-.662-.25-.413-.367-.453-.998-.087-1.413.483-.546.749-1.252.749-1.984 0-1.654-1.346-3-3-3h-.1c-.476 0-.886-.336-.98-.803C15.546 6.345 13.898 5 12 5c-1.897 0-3.546 1.345-3.919 3.197C7.987 8.664 7.576 9 7.1 9H7c-1.654 0-3 1.346-3 3 0 .732.266 1.438.75 1.984.365.415.326 1.046-.088 1.413-.414.366-1.046.325-1.411-.088C2.444 14.396 2 13.221 2 12c0-2.528 1.886-4.624 4.325-4.955C7.146 4.661 9.42 3 12 3zm-.695 8.28c.394-.376 1.017-.373 1.402.013l3 3c.391.391.391 1.023 0 1.414-.195.195-.45.293-.707.293-.256 0-.512-.098-.707-.293L13 14.414V20c0 .553-.448 1-1 1s-1-.447-1-1v-5.644l-1.305 1.26c-.397.385-1.03.372-1.414-.025-.384-.398-.373-1.03.024-1.414l3-2.897z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloudUploadOrange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud_upload_orange.f164bad8.svg";
export { ForwardRef as ReactComponent };